import React from 'react';

// FlowFocus branded workspace icons - minimal, geometric, matching the brand aesthetic
export const WORKSPACE_ICONS = [
  { id: 'bolt', label: 'Blixt', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="url(#bolt-bg)"/>
      <path d="M17.5 8L11 18h4.5l-1 6L21 14h-4.5l1-6z" fill="#09090B" stroke="#09090B" strokeWidth="0.5" strokeLinejoin="round"/>
      <defs><linearGradient id="bolt-bg" x1="0" y1="0" x2="32" y2="32"><stop stopColor="#facc15"/><stop offset="1" stopColor="#f97316"/></linearGradient></defs>
    </svg>
  )},
  { id: 'target', label: 'Mål', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <circle cx="16" cy="16" r="7" stroke="#facc15" strokeWidth="1.5"/>
      <circle cx="16" cy="16" r="4" stroke="#facc15" strokeWidth="1.5"/>
      <circle cx="16" cy="16" r="1.5" fill="#facc15"/>
    </svg>
  )},
  { id: 'rocket', label: 'Raket', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <path d="M16 8c-2 3-3 6-3 9h6c0-3-1-6-3-9z" fill="#facc15"/>
      <path d="M13 17l-2 3h2v3l3-3h-3z" fill="#f97316"/>
      <path d="M19 17l2 3h-2v3l-3-3h3z" fill="#f97316"/>
      <circle cx="16" cy="14" r="1.5" fill="#09090B"/>
    </svg>
  )},
  { id: 'brain', label: 'Hjärna', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <path d="M16 24v-8M12 12c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="#facc15" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M10.5 15c-1.1.9-1.5 2.3-1 3.5.5 1.3 1.8 2 3 2" stroke="#facc15" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M21.5 15c1.1.9 1.5 2.3 1 3.5-.5 1.3-1.8 2-3 2" stroke="#facc15" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="13" cy="13" r="1" fill="#f97316"/>
      <circle cx="19" cy="13" r="1" fill="#f97316"/>
    </svg>
  )},
  { id: 'cube', label: 'Kub', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <path d="M16 9l7 4v7l-7 4-7-4v-7l7-4z" stroke="#facc15" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M16 16l7-4M16 16v8M16 16l-7-4" stroke="#facc15" strokeWidth="1" strokeOpacity="0.5"/>
    </svg>
  )},
  { id: 'star', label: 'Stjärna', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <path d="M16 9l2 5h5l-4 3.5 1.5 5L16 19.5 11.5 22.5 13 17.5 9 14h5l2-5z" fill="#facc15"/>
    </svg>
  )},
  { id: 'flow', label: 'Flow', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <path d="M9 20c3-6 5-4 7-8s4-2 7-8" stroke="#facc15" strokeWidth="2" strokeLinecap="round"/>
      <path d="M9 24c3-6 5-4 7-8s4-2 7-8" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.4"/>
    </svg>
  )},
  { id: 'grid', label: 'Board', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <rect x="9" y="10" width="5" height="12" rx="1.5" stroke="#facc15" strokeWidth="1.5"/>
      <rect x="17" y="10" width="5" height="8" rx="1.5" stroke="#facc15" strokeWidth="1.5"/>
      <rect x="9" y="10" width="5" height="4" rx="1.5" fill="#facc15" fillOpacity="0.3"/>
      <rect x="17" y="10" width="5" height="4" rx="1.5" fill="#facc15" fillOpacity="0.3"/>
    </svg>
  )},
  { id: 'home', label: 'Hem', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <path d="M16 10l-7 6v7h5v-4h4v4h5v-7l-7-6z" stroke="#facc15" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M16 10l-7 6v7h5v-4h4v4h5v-7l-7-6z" fill="#facc15" fillOpacity="0.15"/>
    </svg>
  )},
  { id: 'camera', label: 'Film', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <rect x="8" y="12" width="12" height="9" rx="2" stroke="#facc15" strokeWidth="1.5"/>
      <path d="M20 14.5l4-2v6l-4-2v-2z" fill="#facc15"/>
      <circle cx="13" cy="16.5" r="1" fill="#f97316"/>
    </svg>
  )},
  { id: 'book', label: 'Kunskap', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <path d="M16 22V11M10 10c0 0 2-.5 6 1 4-1.5 6-1 6-1v11c0 0-2-.5-6 1-4-1.5-6-1-6-1V10z" stroke="#facc15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )},
  { id: 'people', label: 'Team', svg: (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1a1a1e"/>
      <circle cx="12" cy="13" r="2.5" stroke="#facc15" strokeWidth="1.5"/>
      <circle cx="20" cy="13" r="2.5" stroke="#facc15" strokeWidth="1.5"/>
      <path d="M8 22c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="#facc15" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M16 22c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  )},
];

export const DEFAULT_ICON = 'bolt';

export function WorkspaceIcon({ iconId, size = 32, className = '' }) {
  const icon = WORKSPACE_ICONS.find(i => i.id === iconId) || WORKSPACE_ICONS[0];
  return (
    <div className={`flex-shrink-0 ${className}`} style={{ width: size, height: size }}>
      {icon.svg}
    </div>
  );
}

export function WorkspaceIconPicker({ selected, onSelect }) {
  return (
    <div className="grid grid-cols-6 gap-2" data-testid="workspace-icon-picker">
      {WORKSPACE_ICONS.map(icon => (
        <button
          key={icon.id}
          onClick={() => onSelect(icon.id)}
          className={`p-1.5 rounded-lg transition-all hover:bg-white/5 ${
            selected === icon.id ? 'ring-2 ring-yellow-400 bg-white/5' : ''
          }`}
          title={icon.label}
          data-testid={`ws-icon-${icon.id}`}
        >
          <div className="w-8 h-8">{icon.svg}</div>
        </button>
      ))}
    </div>
  );
}
